import React, { Component } from 'react';


import AreaComponent from './../components/ChartAreaDashboard/AreaComponent';
import './../../selections/timeSelection/components/timeSelect/cliente.css';


//Actualizacion develop
class AreaDB extends Component {        
        
    render() { 
        const {data, name, title, colors} = this.props;
       return (
            <AreaComponent 
                name={name}
                title={title}
                data={data}
                colors={colors}
                openDialog={this.props.openDialog}
                onClickGraphic={this.props.onClickGraphic}
                seeMore={this.props.seeMore}
            />
        );
    }
}

export default AreaDB;